import React from "react";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { formatIPA } from "../flashcardUtils";

function DeckCardsList({
  cards,
  activeIndex,
  isSignedIn,
  onSelectCard,
  onReviewCard,
}) {
  return (
    <Paper elevation={0} sx={{ mt: 2.5, p: { xs: 2.5, md: 3 }, borderRadius: "14px", bgcolor: "var(--toeic-surface)", boxShadow: "var(--toeic-shadow-card)" }}>
      <Typography sx={{ color: "var(--toeic-ink-deep)", fontWeight: 700, fontSize: 20, mb: 2 }}>
        Cards
      </Typography>
      <Box sx={{ display: "grid", gap: 1, maxHeight: 340, overflowY: "auto" }}>
        {cards.map((card, index) => (
          <Box
            key={card._id}
            onClick={() => onSelectCard(index)}
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 1,
              p: 1.25,
              borderRadius: "12px",
              border: index === activeIndex ? "1.5px solid #6d4aff" : "1px solid #d7eaf5",
              bgcolor: index === activeIndex ? "#faf7ff" : "#fffefd",
              cursor: "pointer",
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ color: "var(--toeic-ink)", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {card.front}
              </Typography>
              {card.ipa && (
                <Typography
                  sx={{
                    color: "#6d4aff",
                    fontFamily: "var(--lingualica-font-ipa)",
                    fontSize: 12,
                    fontWeight: 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatIPA(card.ipa)}
                </Typography>
              )}
              <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {card.back}
              </Typography>
            </Box>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onReviewCard(card);
              }}
              disabled={!isSignedIn}
              size="small"
              sx={{ color: card.remembered ? "#35c759" : "var(--toeic-ink-soft)" }}
            >
              <CheckCircleIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default DeckCardsList;
